import apiClient from './client';

/** Agent 归属转移响应（POST /agents/{id}/transfer） */
export interface AgentTransferResult {
  agent_id: string;
  transferred: boolean;
  already: boolean;
  detail: string;
  warnings: string[];
}

export interface AgentTransferRequest {
  target_email: string;
  target_tenant_id: string;
}

/** 转移 Agent 归属：created_by + tenant_id 转给目标用户/目标租户（幂等）。 */
export async function transferAgent(agentId: string, data: AgentTransferRequest): Promise<AgentTransferResult> {
  const response = await apiClient.post(`/agents/${agentId}/transfer`, data);
  return response.data;
}
